import assetsBase from '@exodus/assets-base'
import { PAYMENT_METHOD_TYPES } from '../constants.js'
import { createPaymentMethod } from '../payment-method.js'

const assets = assetsBase.default || assetsBase

export const RAMP_URL = 'https://app.ramp.network'
export const RAMP_API_URL = 'https://api.ramp.network'

export const ENABLED_CURRENCIES = {
  __proto__: null,
  USD: 'USD',
  EUR: 'EUR',
  GBP: 'GBP',
}

export const ENABLED_ASSETS = {
  __proto__: null,
  ARBITRUM_ETH: assets.ethereumarbone?.name,
  AVAX_AVAX: assets.avalanchec?.name,
  AVAX_USDC: assets.usdc_avalanchec_185c8bd7?.name,
  BASE_ETH: assets.basemainnet?.name,
  BCH_BCH: assets.bcash?.name,
  BSC_BNB: assets.bsc?.name,
  BTC_BTC: assets.bitcoin?.name,
  CARDANO_ADA: assets.cardano?.name,
  COSMOS_ATOM: assets.cosmos?.name,
  DOGE_DOGE: assets.dogecoin?.name,
  ELROND_EGLD: assets.elrond?.name,
  ETH_DAI: assets.mcd?.name,
  ETH_ETH: assets.ethereum?.name,
  ETH_BAT: assets.bat?.name,
  ETH_PAXG: assets.paxgold?.name,
  ETH_LINK: assets.chainlink?.name,
  ETH_MANA: assets.decentraland?.name,
  ETH_USDC: assets.usdcoin?.name,
  ETH_USDT: assets.tetherusd?.name,
  FANTOM_FTM: assets.fantommainnet?.name,
  LTC_LTC: assets.litecoin?.name,
  MATIC_MATIC: assets.matic?.name,
  MATIC_USDC: assets.usdc_matic_0a883d9b?.name,
  OPTIMISM_ETH: assets.optimism?.name,
  OPTIMISM_USDC: assets.usdc_optimism_68bb70cd?.name,
  POLKADOT_DOT: assets.polkadot?.name,
  SOLANA_KIN: assets.kinx_solana_bf1442d2?.name,
  SOLANA_SOL: assets.solana?.name,
  SOLANA_USDT: assets.tetherusd_solana?.name,
  SOLANA_USDC: assets.usdcoin_solana?.name,
  TEZOS_XTZ: assets.tezos?.name,
  TRON_TRX: assets.tronmainnet?.name,
  TRON_USDT: assets.tetherusd_tron?.name,
  XLM_XLM: assets.stellar?.name,
  XRP_XRP: assets.ripple?.name,
  ZILLIQA_ZIL: assets.zilliqa?.name,
}

export const ENABLED_NON_CHAIN_ASSETS = {
  __proto__: null,
  AVAX: 'AVAX_AVAX',
  BCH: 'BCH_BCH',
  BTC: 'BTC_BTC',
  DAI: 'ETH_DAI',
  DOGE: 'DOGE_DOGE',
  DOT: 'POLKADOT_DOT',
  EGLD: 'ELROND_EGLD',
  ETH: 'ETH_ETH',
  LINK: 'ETH_LINK',
  LTC: 'LTC_LTC',
  MANA: 'ETH_MANA',
  MATIC: 'MATIC_MATIC',
  USDC: 'ETH_USDC',
  USDT: 'ETH_USDT',
  XLM: 'XLM_XLM',
  XRP: 'XRP_XRP',
  XTZ: 'TEZOS_XTZ',
}

export const PAYMENT_METHOD_NAMES = {
  __proto__: null,
  apple_pay: 'APPLE_PAY',
  card_payment: 'CARD_PAYMENT',
  manual_bank_transfer: 'MANUAL_BANK_TRANSFER',
  auto_bank_transfer: 'AUTO_BANK_TRANSFER',
}

export const PAYMENT_METHODS = new Map([
  [
    PAYMENT_METHOD_NAMES.apple_pay,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.apple_pay,
      type: PAYMENT_METHOD_TYPES.apple_pay,
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.card_payment,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.card_payment,
      type: PAYMENT_METHOD_TYPES.card,
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.manual_bank_transfer,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.manual_bank_transfer,
      type: PAYMENT_METHOD_TYPES.bank,
      countries: [{ id: 'US', enabled: false }],
      currencies: [{ id: 'USD', enabled: false }],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.auto_bank_transfer,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.auto_bank_transfer,
      type: PAYMENT_METHOD_TYPES.bank,
      countries: [{ id: 'US', enabled: false }],
      currencies: [{ id: 'USD', enabled: false }],
    }),
  ],
])

export const ORDER_STATUSES = {
  __proto__: null,
  cancelled: 'CANCELLED',
  expired: 'EXPIRED',
  fiat_received: 'FIAT_RECEIVED',
  fiat_sent: 'FIAT_SENT',
  initialized: 'INITIALIZED',
  payment_executed: 'PAYMENT_EXECUTED',
  payment_failed: 'PAYMENT_FAILED',
  payment_in_progress: 'PAYMENT_IN_PROGRESS',
  payment_started: 'PAYMENT_STARTED',
  released: 'RELEASED',
  releasing: 'RELEASING',
  review_rejected: 'REVIEW_REJECTED',
}

export const EXODUS_ORDER_STATUSES = {
  __proto__: null,
  complete: [ORDER_STATUSES.released],
  failed: [
    ORDER_STATUSES.cancelled,
    ORDER_STATUSES.expired,
    ORDER_STATUSES.payment_failed,
    ORDER_STATUSES.review_rejected,
  ],
  'in-progress': [
    ORDER_STATUSES.fiat_received,
    ORDER_STATUSES.fiat_sent,
    ORDER_STATUSES.initialized,
    ORDER_STATUSES.payment_executed,
    ORDER_STATUSES.payment_in_progress,
    ORDER_STATUSES.payment_started,
    ORDER_STATUSES.releasing,
  ],
}

export const DEFAULT_FIAT_PRECISION = 2
export const DEFAULT_CRYPTO_PRECISION = 4
